// temporary in-place upgrade of old format
// eventually this can be taken out
const upgrade = (cfg) => {
  cfg = Object.assign({}, cfg)
  if (cfg.rev === 'B') {
    return cfg
  }

  Object.keys(cfg).forEach((k) => {
    // (side effects: cfg)
    if (cfg[k].length) {
      cfg[k] = { labels: cfg[k], isFreeEntry: false }
    }
  })

  return {
    types: cfg,
    rev: 'B',
  }
}
export { upgrade }
export default ($scope) => {
  const set = (updated) => {
    $scope.companySettings.labels = upgrade(updated)
  }

  const get = () => upgrade($scope.companySettings.labels)

  return { get, set }
}
